module.exports = __webpack_public_path__ + "static/media/26-nysgjerrig.e584d2f0.mp3";